<template>
  <v-app>
    <router-view></router-view>
    <UpdateNotification />
  </v-app>
</template>
<script>
import UpdateNotification from '@/components/UpdateNotification.vue'
export default {
  components: {
    UpdateNotification
  },
  name: 'App',
  props: {
    source: String
  }
}
</script>
